import { withDependencies } from '@wix/thunderbolt-ioc'
import { BrowserWindow, BrowserWindowSymbol, LoggerSymbol, ILogger } from '@wix/thunderbolt-symbols'
import { MeasuresApiSymbol } from 'ds-feature-measures-api'
import { ILayoutRuntimeAPI } from './types'
import { LayoutRuntimeCSSPrefix } from '@wix/thunderbolt-catharsis-extensions'

const layoutRuntimeKey = `--${LayoutRuntimeCSSPrefix}`

export const LayoutRuntimeAPI = withDependencies(
	[BrowserWindowSymbol, LoggerSymbol, MeasuresApiSymbol],
	(window: NonNullable<BrowserWindow>, logger: ILogger): ILayoutRuntimeAPI => {
		const api: ILayoutRuntimeAPI = {
			getRuntimeProperty: (compId, properties) => {
				try {
					const componentElement = window.document.getElementById(compId)

					if (componentElement) {
						const computedStyle = window.getComputedStyle(componentElement)

						const getRuntimeProperty = (key: string) => {
							const value = computedStyle.getPropertyValue(`${layoutRuntimeKey}-${key}`)
							return value && value.length > 0 ? JSON.parse(value) : undefined
						}

						return properties.reduce((acc, key) => {
							return {
								...acc,
								[key]: getRuntimeProperty(key),
							}
						}, {})
					}

					return
				} catch (error) {
					logger.captureError(error, {
						tags: { feature: 'layoutRuntimeAPI', methodName: 'getLayoutRuntimeProperty' },
					})
					return
				}
			},
		}

		return api
	}
)
